export const CollapseUp = (props) => {
  const { size = 15, onClick, verticalAlign, marginLeft, marginRight, top, color = '#1A1519', className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 12 6'>
        <path d='M1 0.5L6 5.5L11 0.5' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </span>
  );
};
